import { AlertTriangle, RefreshCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ApiError } from '@/lib/errors';
import { cn } from '@/lib/utils';

interface Props {
  error: unknown;
  onRetry?: () => void;
  className?: string;
}

export function ErrorState({ error, onRetry, className }: Props) {
  const apiError = error instanceof ApiError ? error : null;
  const message = apiError?.message ?? (error instanceof Error ? error.message : 'Something went wrong');
  const code = apiError?.code;

  return (
    <div
      className={cn(
        'flex flex-col items-start gap-3 rounded-lg border border-destructive/20 bg-destructive/5 p-5',
        className,
      )}
      role="alert"
    >
      <div className="flex items-center gap-2 text-destructive">
        <AlertTriangle className="h-4 w-4" />
        <div className="text-sm font-semibold">
          {code ? `${code}` : 'Request failed'}
        </div>
      </div>
      <div className="text-sm text-foreground">{message}</div>
      {apiError?.requestId && (
        <div className="font-mono text-[11px] text-muted-foreground">
          requestId: {apiError.requestId}
        </div>
      )}
      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry} className="mt-1">
          <RefreshCcw className="h-3.5 w-3.5" />
          Try again
        </Button>
      )}
    </div>
  );
}
